import React from 'react'
import { AppBar, Container, Toolbar, styled } from '@mui/material'

const AppBarStyled = styled(AppBar)(({ theme, bgColor }) => ({
    backgroundColor: bgColor,
}))

const ContainerStyled = styled(Container)(({ theme }) => ({
    padding: '0',
    display: 'flex', // for IE
}))

const ToolbarStyled = styled(Toolbar)(({ theme, height }) => ({
    alignItems: 'stretch',
    width: '100%',
    minHeight: height,
}))

const Header = ({ children, bgColor, height, borderBottom = {} }) => {
    return (
        <AppBarStyled bgColor={bgColor} component="div">
            <ContainerStyled maxWidth="100%" style={{ padding: 0 }}>
                <ToolbarStyled
                    style={{ ...borderBottom }}
                    disableGutters
                    height={height}
                >
                    {children}
                </ToolbarStyled>
            </ContainerStyled>
        </AppBarStyled>
    )
}

Header.defaultProps = {
    bgColor: '#fff',
}

export default Header
